module.exports = __webpack_public_path__ + "static/media/choose-plan-multi-company.05e97c2c.svg";